import { type DynamicIslandItinerarySummaryPayload } from "../../dynamicIsland.types";

/**
 * Stable animation session key for itinerary summary payloads.
 *
 * @param payload Itinerary summary island payload.
 * @returns Key that ignores selectedLegId churn.
 */
export function getItinerarySummaryAnimationKey( payload: DynamicIslandItinerarySummaryPayload ): string {
    return `itinerarySummary:${ payload.itineraryId }`;
}
